export default class Tooltip {
  constructor(parent) {
    this.tooltip = document.createElement('div');
    this.tooltip.classList.add('chart-tooltip');
    this.tooltip.style.position = 'absolute';
    parent.appendChild(this.tooltip);
    this.hide();
  }

  show() {
    // this.tooltip.style.position = window.innerWidth < 640
    //   ? 'static'
    //   : 'absolute';
    this.tooltip.style.visibility = 'visible';
  }

  updatePosition(x, y) {
    if (window.innerWidth < 640) {
      this.tooltip.style.left = '50%';
      this.tooltip.style.top = '50%';
      this.tooltip.style.transform = 'translate(-50%, -50%)';
    } else {
      this.tooltip.style.left = `${x}px`;
      this.tooltip.style.top = `${y}px`;
      this.tooltip.style.transform = 'translate(0, 0)';
    }
    this.tooltip.style.visibility = 'visible';
  }

  hide() {
    this.tooltip.style.visibility = 'hidden';
  }

  html(html) {
    this.tooltip.innerHTML = html;
    return this;
  }
}
